import { Box, Flex, Space } from '@mantine/core';
import { translate } from '@shared/i18n/translate.tsx';
import { useParams } from '@tanstack/react-router';

import { CreateConversationWithAdminButton } from '@/features/chat/modules/CreateConversationWithAdminButton';
import { ClubInteractionContainer } from '@/features/work-interactions/containers/ClubInteractionContainer';
import { LBBackButton } from '@/shared/modules';
import { LBLinkButton } from '@/shared/ui-kit/components';

export const SearchClubProfileInfo = () => {
  const { id: artistId, clubId } = useParams({
    from: '/artist/$id/profile-info/$clubId/'
  });

  return (
    <Box>
      <Flex align='center' justify='space-between'>
        <LBBackButton />
        <CreateConversationWithAdminButton>
          <LBLinkButton>{translate('commons.help')}</LBLinkButton>
        </CreateConversationWithAdminButton>
      </Flex>
      <Space h={16} />
      <ClubInteractionContainer artistId={artistId} clubId={clubId} />
    </Box>
  );
};
